import { useContext } from 'react';
import { VoidReturn } from '../../../../Utils/PageUtils';
import { MobileDeviceUnmutedCheckContext } from '../MobileDeviceUnmutedCheckContext';
import { MobileDeviceUnmutedCheckState } from '../MobileDeviceUnmutedCheckModel';
import MelodyAudioService from '../../../../Services/MelodyAudioService';

export type MobileDeviceUnmutedCheckPlayPageHandler = {
    onPlayMedia: () => VoidReturn;
};

export default function useMobileDeviceUnmutedCheckPlayPageHandler(): MobileDeviceUnmutedCheckPlayPageHandler {
    const { setCurrentMobileDeviceUnmutedCheckState } = useContext(
        MobileDeviceUnmutedCheckContext
    );

    const onPlayMedia = async () => {
        const serviceInstance = new MelodyAudioService();
        await serviceInstance.prepAudio(
            '/resources/audio/unmuted-check-jingle.mp3',
            'UnmutedCheckJingle'
        );
        setCurrentMobileDeviceUnmutedCheckState(
            MobileDeviceUnmutedCheckState.Confirmation
        );
    };

    return {
        onPlayMedia,
    };
}
